import { clsx } from "clsx";
import type { ManagedUser } from "@/types/rbac";

interface UserAvatarProps {
  user: Pick<ManagedUser, "firstName" | "lastName" | "avatarUrl">;
  size?: "sm" | "md";
  className?: string;
}

const sizeClasses = {
  sm: "h-8 w-8 text-xs",
  md: "h-9 w-9 text-sm",
};

export function UserAvatar({ user, size = "md", className }: UserAvatarProps) {
  const initials = `${user.firstName[0] ?? ""}${user.lastName[0] ?? ""}`;

  if (user.avatarUrl) {
    return (
      <img
        src={user.avatarUrl}
        alt={`${user.firstName} ${user.lastName}`}
        className={clsx(
          "shrink-0 rounded-full object-cover",
          sizeClasses[size],
          className,
        )}
      />
    );
  }

  return (
    <div
      className={clsx(
        "flex shrink-0 items-center justify-center rounded-full bg-adara-100 font-semibold text-adara-700",
        sizeClasses[size],
        className,
      )}
    >
      {initials}
    </div>
  );
}
